import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa6";
import { MdOutlineContentCopy } from "react-icons/md";

const BillingAddress = () => {
    const navigate = useNavigate();
    const [copied, setCopied] = useState(false);
    const [activeTab, setActiveTab] = useState("local");

    // Object storing addresses dynamically
    const addresses = {
        local: {
            title: "Nigeria Address",
            address: ["15TH Street", "Ikoyi, Lagos", "900000"],
        },
        foreign: {
            title: "United States Address",
            address: ["123 Main Street", "Los Angeles, CA", "90210"],
        },
    };

    const handleGoBack = () => {
        navigate(`/user/cards/1`);
    };

    const handleCopyAddress = (address) => {
        const addressText = address.join(", "); 
        navigator.clipboard.writeText(addressText);
        setCopied(true);

        setTimeout(() => {
            setCopied(false);
        }, 5000);
    };

    return (
        <section className="create__card__page card__fund__page">
            <div className="d-flex align-items-center mt-3">
                <button onClick={handleGoBack} className="btn btn-sm" style={{ color: "#777" }}>
                    <FaAngleLeft size={15} />
                    <span className="ms-1 small mt-1">Back to Card Options</span>
                </button>
            </div>

            <section className="create-card_section">
                <div className="container py-5">
                    <div className="address__display__section custom__tabs">
                        <div className="tabs mt-4 mb-3">
                            {Object.keys(addresses).map((key) => (
                                <div
                                    key={key}
                                    className={`tab ${activeTab === key ? "active" : ""}`}
                                    onClick={() => setActiveTab(key)}
                                >
                                    {addresses[key].title}
                                </div>
                            ))}
                        </div>

                        <div className="tab-content">
                            <section className="address_info">
                                <div className="address_box">
                                    <span className="copy_icon">
                                        <div className="position-relative">
                                            <MdOutlineContentCopy
                                                role="button"
                                                size={24}
                                                color="#141B34"
                                                onClick={() => handleCopyAddress(addresses[activeTab].address)}
                                            />
                                            {copied && (
                                                <div className="copy-tooltip text-white p-2 rounded small">
                                                    Copied!
                                                </div>
                                            )}
                                        </div>
                                    </span>

                                    {addresses[activeTab].address.map((line, index) => (
                                        <p key={index}>{line}</p>
                                    ))}
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </section>
        </section>
    );
};

export default BillingAddress;